module.exports = __webpack_public_path__ + "static/20231130.cf4723fd.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/20231130.png
// module id = 999
// module chunks = 2